function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import ButtonLabel from '../../../Buttons/ButtonLabel/ButtonLabel';
import I18n from '../../../I18n/I18n/I18n';
import IconButton from '../../../Buttons/IconButton/IconButton';
import MimeTypeFileIcon from '../../../SchemaForm/MimeTypeFileIcon/MimeTypeFileIcon';
import React, { useContext, useMemo, useState } from 'react';
import cs from 'classnames';
import en from './locales/File.en.json';
import styles from './File.module.scss';
import CloseX from '../../../Icons/CloseX/CloseX';
import Icon from '../../../Icons/Icon/Icon';
import { ReactComponent as TrashCan } from '../../../../icons/TrashCan/TrashCan.svg';
import compose from '../../../utils/compose';
import uuid from '../../../utils/uuid';
import normalizeLocaleData from '../../../utils/i18n/normalizeLocaleData';
import { withAdditionalIntl } from '../../../I18n/AdditionalIntl/AdditionalIntl';
import ProgressBar from '../../../ProgressBar';
import Tooltip from '../../../Tips/Tooltip/Tooltip';
import MetadataContext from '../../../MetadataContext/MetadataContext';
import ThemeContext from '../../../ThemeContext';
var MESSAGE_PREFIX = '@dm/components.file-input.file';
var messages = normalizeLocaleData(en, MESSAGE_PREFIX);
var messageId = function messageId(id) {
  return "".concat(MESSAGE_PREFIX, ".").concat(id);
};
var toHumanFileSize = function toHumanFileSize(bytes) {
  if (!bytes) {
    return '';
  }
  var exp = Math.log(bytes) / Math.log(1024) | 0;
  if (exp === 0) {
    return bytes + ' bytes';
  }
  var result = (bytes / Math.pow(1024, exp)).toFixed(2);
  return result + ' ' + ('KMGTPEZY'[exp - 1] + 'B');
};
var ProgressBarContainer = function ProgressBarContainer(_ref) {
  var show = _ref.show,
    onCancel = _ref.onCancel,
    progress = _ref.progress;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['progress__container']
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    show: show,
    progress: Math.min(Math.max(progress, 0), 100)
  }), show && /*#__PURE__*/React.createElement(IconButton, {
    className: styles['progress__progress-cancel'],
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(CloseX, {
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    i18nKey: messageId('cancel'),
    hideLabel: true
  })));
};
var ErrorMessage = function ErrorMessage(_ref2) {
  var name = _ref2.name,
    message = _ref2.message;
  var error = message;
  try {
    error = JSON.parse(message);
  } catch (e) {
    // probably not a JSON string, that's okay though
  }
  return /*#__PURE__*/React.createElement("span", {
    className: cs(styles.error, 'error-text')
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(I18n, {
    i18n: messageId("error-upload")
  })), ' ', typeof error === 'string' && error, typeof error === 'object' && error.message, ': ', /*#__PURE__*/React.createElement("div", null, name));
};
var FileName = function FileName(_ref3) {
  var name = _ref3.name,
    fileSize = _ref3.fileSize,
    link = _ref3.link;
  var theme = useContext(ThemeContext);
  var children = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.filename
  }, name), ' ', /*#__PURE__*/React.createElement("span", {
    className: styles['file-size']
  }, "(", toHumanFileSize(fileSize), ")"));
  if (link) {
    return /*#__PURE__*/React.createElement("a", {
      className: cs(styles['file-link'], styles['file-link--anchor'], styles[theme]),
      href: link,
      rel: "noopener noreferrer",
      target: "_blank",
      download: true
    }, children);
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: cs(styles['file-link'], styles['file-link--span'])
    }, children);
  }
};
var IconLink = function IconLink(_ref4) {
  var mimeType = _ref4.mimeType,
    link = _ref4.link;
  var icon = /*#__PURE__*/React.createElement(MimeTypeFileIcon, {
    className: styles['icon'],
    mimeType: mimeType,
    width: 39,
    height: 39
  });
  if (link) {
    return /*#__PURE__*/React.createElement("a", {
      className: cs(styles['icon-link'], styles['icon-link--anchor']),
      href: link,
      rel: "noopener noreferrer",
      target: "_blank",
      download: true
    }, icon, /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: messageId('download'),
      hideLabel: true
    }));
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: cs(styles['icon-link'], styles['icon-link--span'])
    }, icon);
  }
};
var File = function File(props) {
  var errorMessage = props.errorMessage,
    size = props.size,
    disabled = props.disabled,
    fileSize = props.fileSize,
    location = props.location,
    mimeType = props.mimeType,
    name = props.name,
    onCancel = props.onCancel,
    onDelete = props.onDelete,
    progress = props.progress,
    status = props.status;
  var _useState = useState("file-".concat(uuid())),
    _useState2 = _slicedToArray(_useState, 1),
    fileId = _useState2[0];
  var theme = useContext(ThemeContext);
  var _useContext = useContext(MetadataContext),
    httpSessionAliasParamName = _useContext.httpSessionAliasParamName,
    httpSessionAlias = _useContext.httpSessionAlias;
  var locationURL = useMemo(function () {
    if (location) {
      return "".concat(location).concat(location.indexOf('?') > 0 ? '&' : '?').concat(httpSessionAliasParamName, "=").concat(httpSessionAlias);
    }
    return location;
  }, [location, httpSessionAliasParamName, httpSessionAlias]);
  return /*#__PURE__*/React.createElement("li", {
    className: cs(styles.container, styles["container--".concat(size)])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon-container']
  }, /*#__PURE__*/React.createElement(IconLink, {
    mimeType: mimeType,
    link: locationURL
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['details']
  }, /*#__PURE__*/React.createElement("span", {
    id: fileId,
    className: styles.name
  }, status === 'error' && /*#__PURE__*/React.createElement(ErrorMessage, {
    message: errorMessage,
    name: name
  }), status !== 'error' && /*#__PURE__*/React.createElement(FileName, {
    name: name,
    fileSize: fileSize,
    link: locationURL
  })), /*#__PURE__*/React.createElement(ProgressBarContainer, {
    show: status === 'uploading',
    progress: progress,
    onCancel: onCancel
  })), !disabled && (status === 'success' || status === 'error') && /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: messageId('delete')
  }, function (_ref5) {
    var ref = _ref5.ref,
      labelledby = _ref5.labelledby,
      events = _ref5.events;
    return /*#__PURE__*/React.createElement("button", Object.assign({
      ref: ref,
      onClick: onDelete,
      "aria-describedby": fileId,
      "aria-labelledby": labelledby,
      className: cs(styles.delete, 'auto-delete-file-button', styles[theme])
    }, events), /*#__PURE__*/React.createElement(Icon, {
      width: 18,
      height: 18,
      "aria-hidden": true
    }, /*#__PURE__*/React.createElement(TrashCan, {
      width: 18,
      height: 18
    })), /*#__PURE__*/React.createElement("span", {
      className: "assistive-text"
    }, /*#__PURE__*/React.createElement(I18n, {
      i18n: messageId('delete')
    })));
  }));
};
export default compose(withAdditionalIntl({
  messages: messages,
  path: '_PROPOSED_/FileInput/File/locales/File',
  namespace: MESSAGE_PREFIX
}))(File);